import { PHOTOS } from "@/data/photos";

// Shared photography block: locally hosted WebP, focal-cropped, lazy-loaded by
// default (set priority for above-the-fold heroes), always alt-described.
export const Photo = ({
  slug,
  ratio = "aspect-[4/3]",
  rounded = "rounded-3xl",
  className = "",
  imgClassName = "",
  priority = false,
  children,
  ...rest
}) => {
  const photo = PHOTOS[slug];
  if (!photo) return null;
  return (
    <figure className={`relative overflow-hidden ${rounded} ${ratio} ${className}`} {...rest}>
      <img
        src={photo.src}
        alt={photo.alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={priority ? "high" : "auto"}
        className={`h-full w-full object-cover ${imgClassName}`}
      />
      {children}
    </figure>
  );
};

export default Photo;

